import { getUmbracoMediaUrl } from "@eurodrive/utils/getUmbracoMediaUrl"
import { videoCompleted, videoPlayed } from "@eurodrive/utils/gtm"
import Image from "next/image"
import { Dispatch, SetStateAction, useState } from "react"
// import ReactPlayer from "react-player"
import dynamic from "next/dynamic"
import { useIsDesktop } from "./MediaQueries"

const ReactPlayer = dynamic(() => import("react-player/lazy"), { ssr: false })

export const isVideo = (url: string): boolean => {
  return (
    url.includes(".mp4") ||
    url.includes(".webm") ||
    url.includes("youtube") ||
    url.includes("youtu.be")
  )
}

type Props = {
  source: string
  playing: boolean
  setPlaying: Dispatch<SetStateAction<boolean>>
  volume: boolean
  setVolume: Dispatch<SetStateAction<boolean>>
  videoId?: string
  locationOnPage?: string
}

const ReactPlayerComponent = ({
  source,
  playing,
  volume,
  videoId,
  locationOnPage = "banner",
}: Props): JSX.Element => {
  const isMediaVideo = isVideo(source)
  const isDesktop = useIsDesktop()
  const [hasStartedTracked, setHasStartedTracked] = useState(false)
  const [hasCompletedTracked, setHasCompletedTracked] = useState(false)

  const handlePlay = () => {
    if (!hasStartedTracked) {
      videoPlayed(videoId || source, locationOnPage)
      setHasStartedTracked(true)
    }
  }

  const handleEnded = () => {
    if (!hasCompletedTracked) {
      videoCompleted(videoId || source, locationOnPage)
      setHasCompletedTracked(true)
    }
  }

  return isMediaVideo ? (
    <ReactPlayer
      controls={false}
      muted={!volume}
      loop
      playing={playing}
      url={getUmbracoMediaUrl(source)}
      width={"100%"}
      height={isDesktop ? "100%" : "340px"}
      playsinline={true}
      onPlay={handlePlay}
      onEnded={handleEnded}
      config={{
        file: {
          attributes: {
            autoPlay: true,
            playsInline: true,
            muted: true,
            preload: "auto",
            style: { objectFit: "cover", width: "100%", height: "100%" },
          },
          forceVideo: true,
        },
      }}
      style={{ display: "flex", position: "absolute", inset: 0 }}
    />
  ) : (
    <Image
      src={getUmbracoMediaUrl(source)}
      alt="hero"
      fill
      style={{ objectFit: "cover" }}
      priority
    />
  )
}

export default ReactPlayerComponent
